import React from 'react';
import { Switch, useRouteMatch, Route } from 'react-router-dom';
import NotFound from '../../utils/404';

import BotLicenseManagement from '../../pages/admin/bot-license/index';

const BotLicensesRoute = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${path}`} component={BotLicenseManagement} />
      <Route component={NotFound} />
    </Switch>
  );
};

export default BotLicensesRoute;
